import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Ruler, CheckCircle2, Download } from "lucide-react";
import { MEETHANDLEIDING_PDF } from "@/lib/offerteOptions";

const STAPPEN = [
  { t: "Meet altijd in millimeters", d: "Noteer breedte × hoogte in mm. Meet op 3 plaatsen (boven, midden, onder voor de breedte; links, midden, rechts voor de hoogte) en gebruik telkens de kleinste maat." },
  { t: "Meet de dagmaat (kozijnopening)", d: "Meet de vrije opening in de muur waar het raam of de deur in komt — niet het bestaande kader. Verwijder eventueel sierlijsten om de echte opening te zien." },
  { t: "Controleer haaksheid", d: "Meet beide diagonalen. Zijn ze gelijk, dan is de opening haaks. Verschil > 5 mm? Vermeld dit bij de opmerkingen." },
  { t: "Deuren: meet ook de drempel", d: "Geef aan of er een vaste drempel is en de hoogte ervan. Vermeld de draairichting (naar binnen/buiten, links/rechts)." },
  { t: "Veluxramen: noteer het type/maat", d: "Op het bestaande Veluxraam staat meestal een typeplaatje (bv. MK06). Noteer dit; anders breedte × hoogte van de dakopening." },
  { t: "Garagepoorten: meet de volledige opening", d: "Breedte × hoogte van de opening + de beschikbare ruimte links, rechts en boven (latei) voor de geleiding." },
];

export function MeetHandleiding() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button type="button" data-testid="meethandleiding-btn" variant="outline"
          className="rounded-sm font-semibold border-slate-300 hover:border-orange-400 hover:text-orange-600">
          <Ruler className="w-4 h-4 mr-2" /> Meethandleiding
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="meethandleiding-dialog" className="rounded-md max-w-3xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display">Hoe meet ik ramen en deuren correct op?</DialogTitle>
          <DialogDescription>Bekijk of download de handleiding en volg de stappen voor een nauwkeurige opmeting.</DialogDescription>
        </DialogHeader>
        <a href={MEETHANDLEIDING_PDF} target="_blank" rel="noopener noreferrer" data-testid="meethandleiding-download">
          <Button type="button" className="bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-bold mb-2">
            <Download className="w-4 h-4 mr-2" /> Download de volledige handleiding (PDF)
          </Button>
        </a>
        <div className="rounded-sm overflow-hidden border border-slate-200 mb-4">
          <iframe data-testid="meethandleiding-pdf" src={MEETHANDLEIDING_PDF} title="Meethandleiding" className="w-full h-[420px] bg-white" />
        </div>
        <p className="text-sm text-slate-600 mb-2">Korte samenvatting:</p>
        <ol className="space-y-3">
          {STAPPEN.map((s, i) => (
            <li key={s.t} className="flex gap-3">
              <CheckCircle2 className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold text-slate-900 text-sm">{s.t}</p>
                <p className="text-sm text-slate-600">{s.d}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className="mt-4 bg-orange-50 border border-orange-200 rounded-sm px-4 py-3 text-sm text-orange-800">
          <strong>Tip:</strong> voeg foto's van de bestaande situatie en een eventueel plan toe aan je aanvraag. Zo kunnen bedrijven een veel nauwkeurigere offerte maken.
        </div>
      </DialogContent>
    </Dialog>
  );
}
